import React, { useState, useCallback } from 'react'
import Image from 'next/image'

const ImageWithFallback = ({
  src,
  alt,
  width,
  height,
  className = '',
  fallbackSrc = '/assets/agents-dummy/placeholder.svg',
  blurDataURL = '/assets/agents-dummy/placeholder.svg',
  priority = false,
  loading = 'lazy',
  onError,
  ...props
}) => {
  const [imageUrl, setImageUrl] = useState(src || fallbackSrc)

  const handleImageError = useCallback(() => {
    setImageUrl(fallbackSrc)
    if (onError) {
      onError()
    }
  }, [fallbackSrc, onError])

  return (
    <Image
      src={imageUrl}
      alt={alt}
      width={width}
      height={height}
      className={className}
      onError={handleImageError}
      placeholder="blur"
      blurDataURL={blurDataURL}
      priority={imageUrl !== fallbackSrc ? priority : false}
      loading={imageUrl === fallbackSrc ? 'lazy' : loading}
      {...props}
    />
  )
}

export default ImageWithFallback
